import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f4b568e4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "back-content"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("使用商家推广工具（3选1）");
const _hoisted_4 = {
  key: 0,
  class: "activity_list"
};
const _hoisted_5 = {
  class: "activity_item"
};
const _hoisted_6 = {
  class: "label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: $options.ifShow,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $options.ifShow = $event),
    class: "pop-back",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: _normalizeClass(["tit", _ctx.has_message])
    }, [_hoisted_3, _createVNode(_component_van_icon, {
      class: "icon",
      name: "close",
      size: "20",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.ifShow = false, ["stop"]))
    })], 2), $data.three_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.three_list, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "normal_item"
      }, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.task_name), 1), _createElementVNode("div", {
        class: _normalizeClass(['right_btn', {
          'disabled': item.task_status == 20
        }]),
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.btnAction(), ["stop"]))
      }, _toDisplayString(item.task_status == 10 ? '领取' : item.button_name), 3)]);
    }), 128))])])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["show"])]);
}